import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { forgotPasswordRequest } from '../../services/auth/forgotPasswordService.js';
import {isEmailValid } from '../../utils/validations/forgotPasswordValidations.js';
import ROUTES from '../../routes/Routes.js';

export const useForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    /* modales */
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!isEmailValid(email)) {
            setErrorMessage('El correo electrónico no es válido.');
            setShowErrorModal(true);
            return;
        }

        try {
            setLoading(true);
            await forgotPasswordRequest(email);
            setSuccessMessage('Correo de recuperación enviado.');
            setShowSuccessModal(true);
        } catch (error) {
            setErrorMessage(
            error.response?.data?.error ||'Error al enviar el correo de recuperación.');
            setShowErrorModal(true);
        } finally {
            setLoading(false);
        }
    };

    const closeSuccessModal = () => {
        setShowSuccessModal(false);
        navigate(ROUTES.LOGIN);
    };

    const closeErrorModal = () => {
        setShowErrorModal(false);
    };

    return {
        email,
        setEmail,
        loading,
        handleSubmit,
        showErrorModal,
        errorMessage,
        closeErrorModal,
        showSuccessModal,
        successMessage,
        closeSuccessModal
    };
};